import { ButtonProps } from '@material-ui/core/Button/Button';

import { ButtonPelican } from './component';
import { Props } from './props';

export type ButtonPelicanProps = Props & ButtonProps;
export * from './component';

export default ButtonPelican;
